import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import EmployerHeaderScreen from "../../component/layout/employerheader";
import EmployerSidebarScreen from "../../component/layout/employer-sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Form from 'react-bootstrap/Form';
import { useFormik } from 'formik';
import * as yup from "yup";
import {  toast } from "react-toastify";
import { viewJobApi, updateJobApi, jobTypeApi, jobCategoryApi } from  '../../service/apis/employer.api';
import { useParams } from 'react-router-dom';
import { TagsInput } from "react-tag-input-component";
import { ButtonLoader } from "../../common/Loader/loader";
import { AppRoute } from "../../router/routerConstants";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import ReactQuill from 'react-quill';

const EmpEditJobScreen = () => {
    const [jobCategory, setJobCategory] = useState([]);
    const [jobType, setJobType] = useState([]);
    const { jobId } = useParams();

    const [selectedJob, setSelectedJob] = useState<any>(null);

    const [NavigateTo] = useCustomNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const displayJobData = async (jobIdd: any) => {
        try {
            const data = await viewJobApi(jobIdd);
            //console.log(data);
            setSelectedJob(data);
        } catch (error) {
            console.error('Error fetching job details:', error);
        }
    };

    const decodeHtml = (html ="") => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };  

    useEffect(()=>{
        displayJobData(jobId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const skillString = selectedJob?.job?.skill;
    const skillsArray = skillString ? skillString.split(',').map( (skill: any) => skill.trim()) : [];

    //Update job
    const today = new Date().toISOString().split("T")[0];
    // 10-12-24
    const EditFormFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            //jobTitle: selectedJob?.jobTitle || "",
            jobTitle: selectedJob?.job?.title || "",
            jobCategory: selectedJob?.job?.category?._id || "",
            jobType: selectedJob?.job?.type?._id || "",
            salaryStart: selectedJob?.job?.salaryMin || "",
            salaryEnd: selectedJob?.job?.salaryMax || "",
            Experience: selectedJob?.job?.experience || "",
            Qualification: selectedJob?.job?.qualification || "",
            //Skills: selectedJob?.job?.skill || "",
            Skills: skillsArray || "",
            Vacancies: selectedJob?.job?.vacancy || "",
            jobLocation: selectedJob?.job?.location || "",
            applicationDate: selectedJob?.job?.deadlineDate || "",
            jobDescription: selectedJob?.job?.description? decodeHtml(selectedJob?.job?.description): "",
            Responsibilities:selectedJob?.job?.responsibilities? decodeHtml(selectedJob?.job?.responsibilities): "",
            skillDes: selectedJob?.job?.des_skills? decodeHtml(selectedJob?.job?.des_skills): "",
        },
        validationSchema: yup.object({
            jobTitle: yup
            .string()
            .trim()
            .min(2, "Minimum length should be 2")
            .required("Job Title is required"),

            jobCategory: yup
            .string()
            .required("Please select a job category"),

            jobType: yup
            .string()
            .required("Please select a job type"),

            salaryStart: yup
            .number()
            .typeError('Must be a number')
            .min(100, "Minimum length should be 3")
            .required("Salary start range is required"),

            salaryEnd: yup
            .number()
            .typeError('Must be a number')
            .min(yup.ref('salaryStart'), 'Range must be equal or greater than previous field')
            .required("Salary end range is required"),

            Experience: yup
            .string()
            .required("Please select Experience"),

            Qualification: yup
            .string()
            .trim()
            .required("Qualification is required"),

            /*Skills: yup
            .string()
            .trim()
            .required("Skills is required"),*/

            Skills: yup
                .array()
                .of(yup.string().trim().required("Skills are required"))
                .min(1, "At least one skill is required"),

            Vacancies: yup
            .number()
            .typeError('Must be a number')
            .min(1, "Minimum 1 vanacy is required")
            .required("Vacancies is required"),

            jobLocation: yup
            .string()
            .trim()
            .required("Job Location is required"),

            applicationDate: yup.date()
            .min(today, "Date cannot be in the past")
            .required("Application Date is required"),

            jobDescription: yup
            .string()
            .required("Job Description is required"),

            Responsibilities: yup
            .string()
            .required("Responsibilities is required"),

            skillDes: yup
            .string()
            .required("Skills Description is required"),
        }),
        onSubmit: async (values: any) => {
            //setLoading(true);
            const skillsAsString = values.Skills.join(", ");
            try {
                setIsLoading(true);
                //let description = values.jobDescription,
                //sanitizedDescription = sanitizeHtml(description, sanitizeOptions);

                const bodyData = {
                    title: values?.jobTitle,
                    category: values?.jobCategory,
                    type: values?.jobType,
                    salaryMin: values?.salaryStart,
                    salaryMax: values?.salaryEnd,
                    experience: values?.Experience,
                    qualification: values?.Qualification,
                    //skill: values.Skills,
                    skill: skillsAsString,
                    des_skills: values?.skillDes,
                    responsibilities: values?.Responsibilities,
                    vacancy: values?.Vacancies,
                    location: values?.jobLocation,
                    deadlineDate: values?.applicationDate,
                    description: values?.jobDescription,
                    //status: selectedJob?.job?.status

                    //description: sanitizedDescription
                };
                const currntJobId = selectedJob?.job?.id;

                const responsee = await updateJobApi(currntJobId, bodyData);

                if(responsee?.message === "Job Updated successfully"){
                    toast.success(responsee?.message);
                    setTimeout(() => {
                        NavigateTo(AppRoute.EMPLOYER_MANAGE_JOBS);
                    }, 1000);
                } else {
                    toast.error("Failed to create job!!");
                }
            } 
            catch(error) {
                toast.error("An error occurred while creating the job!!");
                // console.log(error);
            } finally {
                setIsLoading(false);
            }
        }
    });
    //Update job ends

    const jobCategoryLists = async() => {
        //setIsLoading(true);
        try {
            const response = await jobCategoryApi();
            setJobCategory(response?.categories);
        } catch (error) {
            console.error("Catch Error: ", error);
        } finally {
            //setIsLoading(false);
        }
    };
    
    const jobTypeLists = async() => {
        //setIsLoading(true);
        try {
            const response = await jobTypeApi();
            setJobType(response?.types);
        } catch (error) {
            console.error("Catch Error: ", error);
        } finally {
            //setIsLoading(false);
        }
    };
    
    useEffect(() => {
        jobCategoryLists();
        jobTypeLists();
    }, []);

    return (
        <>
            {/* selectedJob ? ( */ }
                <div className="main">
                    <section className="profileJoblisting-area">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-2 sidebar position-relative p-0">
                                    <EmployerSidebarScreen />
                                </div>
                                <div className="col-lg-10 rightcontent p-0">
                                    <EmployerHeaderScreen />
                                    <div className="profileJoblisting-holder rightInnerScroll">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="applied-title">
                                                    <div className="title">
                                                        <h2>Edit Job</h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-10">
                                                <Form onSubmit={EditFormFormik.handleSubmit}>
                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            {/* <div className="form-group mb-4"> */}
                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>Job Title</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="jobTitle" 
                                                                    value={EditFormFormik.values.jobTitle}
                                                                    //value={selectedJob.job.title || ''} 
                                                                    placeholder="Enter job title" 
                                                                    onChange={EditFormFormik.handleChange}
                                                                    isInvalid={
                                                                        !!EditFormFormik.errors.jobTitle && 
                                                                        Boolean(EditFormFormik.touched.jobTitle)
                                                                    }
                                                                />
                                                                {/* <Form.Control type="text" name="jobTitle" placeholder="Enter job title" /> */}
                                                            </Form.Group>
                                                            {/* </div> */}
                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.jobTitle === "string" && EditFormFormik.errors.jobTitle}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            {/* <div className="form-group  mb-4"> */}
                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>Job Category</Form.Label>
                                                                <Form.Select 
                                                                    className="form-control" 
                                                                    name="jobCategory"  
                                                                    aria-label="Default select example" 
                                                                    value={EditFormFormik.values.jobCategory}
                                                                    onChange={EditFormFormik.handleChange}
                                                                    isInvalid={
                                                                        !!EditFormFormik.errors.jobCategory && 
                                                                        Boolean(EditFormFormik.touched.jobCategory)
                                                                    }
                                                                >
                                                                    <option>Select job category</option>
                                                                    {jobCategory ? ( jobCategory.map((jobCat: any, index: any) => (
                                                                        <option key={index} value={jobCat.id}>{jobCat.categoryName}</option>
                                                                        ))):<></>
                                                                    }
                                                                </Form.Select>
                                                            </Form.Group>
                                                            {/* </div> */}
                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.jobCategory === "string" && EditFormFormik.errors.jobCategory}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>Job Type</Form.Label>
                                                                <Form.Select 
                                                                    name="jobType" 
                                                                    className="form-control" 
                                                                    aria-label="Default select example" 
                                                                    value={EditFormFormik.values.jobType}
                                                                    onChange={EditFormFormik.handleChange}
                                                                    isInvalid={
                                                                        !!EditFormFormik.errors.jobType && 
                                                                        Boolean(EditFormFormik.touched.jobType)
                                                                    }
                                                                >
                                                                    <option>Select job type</option>
                                                                    {jobType ? ( jobType.map((jobtpe: any, index: any) => (
                                                                        <option key={index} value={jobtpe.id}>{jobtpe.typeName}</option>
                                                                        ))):<></>
                                                                    }
                                                                </Form.Select>
                                                            </Form.Group>
                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.jobType === "string" && EditFormFormik.errors.jobType}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>Salary Range</Form.Label>
                                                                <Form.Control 
                                                                    name="salaryStart" 
                                                                    type="text" 
                                                                    value={EditFormFormik.values.salaryStart} 
                                                                    placeholder="$00" 
                                                                    onChange={EditFormFormik.handleChange}
                                                                    isInvalid={
                                                                        !!EditFormFormik.errors.salaryStart && 
                                                                        Boolean(EditFormFormik.touched.salaryStart)
                                                                    }
                                                                />
                                                            </Form.Group>
                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.salaryStart === "string" && EditFormFormik.errors.salaryStart}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>&nbsp;</Form.Label>
                                                                <Form.Control 
                                                                    name="salaryEnd" 
                                                                    type="text" 
                                                                    value={EditFormFormik.values.salaryEnd} 
                                                                    placeholder="$00" 
                                                                    onChange={EditFormFormik.handleChange}
                                                                    isInvalid={
                                                                        !!EditFormFormik.errors.salaryEnd && 
                                                                        Boolean(EditFormFormik.touched.salaryEnd)
                                                                    }
                                                                />
                                                            </Form.Group>
                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.salaryEnd === "string" && EditFormFormik.errors.salaryEnd}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>Job Experience</Form.Label>
                                                                <Form.Select 
                                                                    name="Experience" 
                                                                    className="form-control" 
                                                                    aria-label="Default select example" 
                                                                    value={EditFormFormik.values.Experience}
                                                                    onChange={EditFormFormik.handleChange}
                                                                    isInvalid={
                                                                        !!EditFormFormik.errors.Experience && 
                                                                        Boolean(EditFormFormik.touched.Experience)
                                                                    }
                                                                >
                                                                    <option>Select job experience</option>
                                                                    <option value="1 - 3 years">1 - 3 years</option>
                                                                    <option value="3 - 5 years">3 - 5 years</option>
                                                                    <option value="5 - 10 years">5 - 10 years</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.Experience === "string" && EditFormFormik.errors.Experience}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>Qualification</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="Qualification" 
                                                                    value={EditFormFormik.values.Qualification} 
                                                                    placeholder="Enter qualification" 
                                                                    onChange={EditFormFormik.handleChange}
                                                                    isInvalid={
                                                                        !!EditFormFormik.errors.Qualification && 
                                                                        Boolean(EditFormFormik.touched.Qualification)
                                                                    }
                                                                />
                                                            </Form.Group>
                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.Qualification === "string" && EditFormFormik.errors.Qualification}
                                                            </Form.Control.Feedback>
                                                        </div>

                                                        <div className="col-lg-6">
                                                            {/* <Form.Group className="form-group mb-4">
                                                                <Form.Label>Skill Required</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="Skills" 
                                                                    value={EditFormFormik.values.Skills} 
                                                                    placeholder="Enter required skills" 
                                                                    onChange={EditFormFormik.handleChange}
                                                                    isInvalid={
                                                                        !!EditFormFormik.errors.Skills && 
                                                                        Boolean(EditFormFormik.touched.Skills)
                                                                    }
                                                                />
                                                            </Form.Group>
                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.Skills === "string" && EditFormFormik.errors.Skills}
                                                            </Form.Control.Feedback> */}

                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>
                                                                    Skill Required{" "}
                                                                    <span className="text-danger">
                                                                    ( Press Enter after entering a value. )
                                                                    </span>
                                                                </Form.Label>

                                                                <TagsInput
                                                                    value={EditFormFormik.values.Skills}
                                                                    onChange={(value) =>
                                                                        EditFormFormik.setFieldValue(
                                                                            "Skills",
                                                                            value
                                                                        )
                                                                    }
                                                                    //onChange={(newTags) => setSkills("Skills", newTags)}
                                                                    name="Skills"
                                                                    placeHolder="Add skills"
                                                                />
                                                            </Form.Group>

                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.Skills ===
                                                                    "string" && EditFormFormik.errors.Skills}
                                                            </Form.Control.Feedback>
                                                        </div>

                                                        <div className="col-lg-6">
                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>Number of Vacancies</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="Vacancies" 
                                                                    value={EditFormFormik.values.Vacancies} 
                                                                    placeholder="Enter number of vacancies" 
                                                                    onChange={EditFormFormik.handleChange}
                                                                    isInvalid={
                                                                        !!EditFormFormik.errors.Vacancies && 
                                                                        Boolean(EditFormFormik.touched.Vacancies)
                                                                    }
                                                                />
                                                            </Form.Group>
                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.Vacancies === "string" && EditFormFormik.errors.Vacancies}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>Job Location</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="jobLocation" 
                                                                    value={EditFormFormik.values.jobLocation} 
                                                                    placeholder="Enter number of vacancies" 
                                                                    onChange={EditFormFormik.handleChange}
                                                                    isInvalid={
                                                                        !!EditFormFormik.errors.jobLocation && 
                                                                        Boolean(EditFormFormik.touched.jobLocation)
                                                                    }
                                                                />
                                                            </Form.Group>
                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.jobLocation === "string" && EditFormFormik.errors.jobLocation}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>Application Deadline Date</Form.Label>
                                                                <Form.Control 
                                                                    type="date" 
                                                                    name="applicationDate" 
                                                                    value={EditFormFormik.values.applicationDate.split('T')[0]} 
                                                                    placeholder="Enter required skills" 
                                                                    onChange={EditFormFormik.handleChange}
                                                                    isInvalid={
                                                                        !!EditFormFormik.errors.applicationDate && 
                                                                        Boolean(EditFormFormik.touched.applicationDate)
                                                                    }
                                                                />
                                                            </Form.Group>
                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.applicationDate === "string" && EditFormFormik.errors.applicationDate}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>Job Description</Form.Label>

                                                                {/* <Editor
                                                                    id="jobDescription"
                                                                    apiKey="tdr5u3hs5sq6n7v1xnf9w3e12tfsg3yeroch75k8gegz39nb"
                                                                    init={{
                                                                        height: 300,
                                                                        menubar: false,
                                                                        plugins: 'preview importcss searchreplace autolink directionality code visualblocks visualchars fullscreen link table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
                                                                        toolbar:
                                                                            "undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | pagebreak anchor codesample | ltr rtl",
                                                                        placeholder: 'Enter job description here...',
                                                                        block_formats: 'Paragraph=p;Header 1=h1;Header 2=h2;Header 3=h3'
                                                                        
                                                                    }}
                                                                    value={EditFormFormik.values.jobDescription} 
                                                                    onEditorChange={(content) => {
                                                                        EditFormFormik.setFieldValue('jobDescription', content);
                                                                        EditFormFormik.setFieldTouched('jobDescription', true);
                                                                    }}
                                                                /> */}
                                                                <ReactQuill
                                                                    theme="snow"
                                                                    value={EditFormFormik.values.jobDescription}
                                                                    onChange={(content) => {
                                                                        EditFormFormik.setFieldValue("jobDescription", content);
                                                                        EditFormFormik.setFieldTouched("jobDescription", true);
                                                                    }}
                                                                    placeholder="Enter Job Description here..."
                                                                    style={{ height: "200px", marginBottom: "40px" }}
                                                                    modules={{
                                                                        toolbar: [
                                                                            [{ header: [1, 2, 3, false] }],
                                                                            ["bold", "italic", "underline", "strike"],
                                                                            [{ list: "ordered" }, { list: "bullet" }],
                                                                            ["link", "blockquote", "code-block"],
                                                                            [{ color: [] }, { background: [] }],
                                                                            [{ align: [] }],
                                                                            [{ font: [] }],
                                                                            ["clean"],
                                                                        ],
                                                                    }}
                                                                    formats={[
                                                                        "header",
                                                                        "bold",
                                                                        "italic",
                                                                        "underline",
                                                                        "strike",
                                                                        "list",
                                                                        "bullet",
                                                                        "link",
                                                                        "blockquote",
                                                                        "code-block",
                                                                        "color",
                                                                        "background",
                                                                    ]}
                                                                />

                                                            </Form.Group>

                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.jobDescription === "string" && EditFormFormik.errors.jobDescription}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>Required Experience, Skills and Qualifications</Form.Label>

                                                                {/* <Editor
                                                                    id="skillDes" 
                                                                    apiKey="tdr5u3hs5sq6n7v1xnf9w3e12tfsg3yeroch75k8gegz39nb"
                                                                    init={{
                                                                        height: 300,
                                                                        menubar: false,
                                                                        plugins: 'preview importcss searchreplace autolink directionality code visualblocks visualchars fullscreen link table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
                                                                        toolbar:
                                                                            "undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | pagebreak anchor codesample | ltr rtl",
                                                                        placeholder: 'Enter job description here...',
                                                                    }}
                                                                    value={EditFormFormik.values.skillDes}
                                                                    onEditorChange={(content) => {
                                                                        EditFormFormik.setFieldValue('skillDes', content);
                                                                        EditFormFormik.setFieldTouched('skillDes', true);
                                                                    }}
                                                                /> */}
                                                                <ReactQuill
                                                                    theme="snow"
                                                                    value={EditFormFormik.values.skillDes}
                                                                    onChange={(content) => {
                                                                        EditFormFormik.setFieldValue("skillDes", content);
                                                                        EditFormFormik.setFieldTouched("skillDes", true);
                                                                    }}
                                                                    placeholder="Enter Required Experience, Skills and Qualifications here..."
                                                                    style={{ height: "200px", marginBottom: "40px" }}
                                                                    modules={{
                                                                        toolbar: [
                                                                            [{ header: [1, 2, 3, false] }],
                                                                            ["bold", "italic", "underline", "strike"],
                                                                            [{ list: "ordered" }, { list: "bullet" }],
                                                                            ["link", "blockquote", "code-block"],
                                                                            [{ color: [] }, { background: [] }],
                                                                            [{ align: [] }],
                                                                            [{ font: [] }],
                                                                            ["clean"],
                                                                        ],
                                                                    }}
                                                                    formats={[
                                                                        "header",
                                                                        "bold",
                                                                        "italic",
                                                                        "underline",
                                                                        "strike",
                                                                        "list",
                                                                        "bullet",
                                                                        "link",
                                                                        "blockquote",
                                                                        "code-block",
                                                                        "color",
                                                                        "background",
                                                                    ]}
                                                                />
                                                            </Form.Group>
                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.skillDes === "string" && EditFormFormik.errors.skillDes}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <Form.Group className="form-group mb-4">
                                                                <Form.Label>Responsibilites and Duties</Form.Label>
                                                                {/* <Editor
                                                                    id="Responsibilities"
                                                                    apiKey="tdr5u3hs5sq6n7v1xnf9w3e12tfsg3yeroch75k8gegz39nb"
                                                                    init={{
                                                                        height: 300,
                                                                        menubar: false,
                                                                        plugins: 'preview importcss searchreplace autolink directionality code visualblocks visualchars fullscreen link table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
                                                                        toolbar:
                                                                            "undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | pagebreak anchor codesample | ltr rtl",
                                                                        placeholder: 'Enter job description here...',
                                                                    }}
                                                                    value={EditFormFormik.values.Responsibilities}
                                                                    onEditorChange={(content) => {
                                                                        EditFormFormik.setFieldValue('Responsibilities', content);
                                                                        EditFormFormik.setFieldTouched('Responsibilities', true);
                                                                    }}
                                                                /> */}
                                                                <ReactQuill
                                                                    theme="snow"
                                                                    value={EditFormFormik.values.Responsibilities}
                                                                    onChange={(content) => {
                                                                        EditFormFormik.setFieldValue("Responsibilities", content);
                                                                        EditFormFormik.setFieldTouched("Responsibilities", true);
                                                                    }}
                                                                    placeholder="Enter Responsibilities and Duties here..."
                                                                    style={{ height: "200px", marginBottom: "40px" }}
                                                                    modules={{
                                                                        toolbar: [
                                                                            [{ header: [1, 2, 3, false] }],
                                                                            ["bold", "italic", "underline", "strike"],
                                                                            [{ list: "ordered" }, { list: "bullet" }],
                                                                            ["link", "blockquote", "code-block"],
                                                                            [{ color: [] }, { background: [] }],
                                                                            [{ align: [] }],
                                                                            [{ font: [] }],
                                                                            ["clean"],
                                                                        ],
                                                                    }}
                                                                    formats={[
                                                                        "header",
                                                                        "bold",
                                                                        "italic",
                                                                        "underline",
                                                                        "strike",
                                                                        "list",
                                                                        "bullet",
                                                                        "link",
                                                                        "blockquote",
                                                                        "code-block",
                                                                        "color",
                                                                        "background",
                                                                    ]}
                                                                />
                                                            </Form.Group>
                                                            <Form.Control.Feedback type="invalid">
                                                                {typeof EditFormFormik.errors.Responsibilities === "string" && EditFormFormik.errors.Responsibilities}
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <Button className="btn" type="submit">
                                                                    {isLoading ? <ButtonLoader /> : "Update Job"}
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div >
            {/*) : (
                <div className='main'>Job details not found</div>
            )} */}

            <AuthFooterScreen />

            {/* <ToastContainer /> */}

        </>
    )
}
export default EmpEditJobScreen;